/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Stephan JAMBOU
 * @date        22/04/2022 10:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Banner from '@scripts/components/banner'
import Navbar from '@scripts/components/navbar'

document.addEventListener('DOMContentLoaded', () => {
    new Banner()
    new Navbar()
    if ($('.home').length > 0) {
        import('@scripts/components/home' /* webpackChunkName: "scripts/home" */).then(
            ({ default: Home }) => {
                new Home()
            },
        )
    }
    if ($('.fullscreen').length > 0) {
        import('@scripts/services/layout' /* webpackChunkName: "scripts/layout" */).then(
            ({ default: Layout }) => {
                new Layout()
            },
        )
    }

    const toggleInfoLive = (mode = 'toggle') => {
        if (mode === 'show') {
            if (!$('#infos-live').hasClass('active')) {
                $('#infos-live').addClass('active')
            }
            if (!$('.infos-live__overlay').hasClass('active')) {
                $('.infos-live__overlay').addClass('active')
            }
            if (!$('body').hasClass('infos-live-is-open')) {
                $('body').addClass('infos-live-is-open')
            }
        } else if (mode === 'hide') {
            $('#infos-live').removeClass('active')
            $('.infos-live__overlay').removeClass('active')
            $('body').removeClass('infos-live-is-open')
        } else {
            $('#infos-live').toggleClass('active')
            $('.infos-live__overlay').toggleClass('active')
            $('body').toggleClass('infos-live-is-open')
        }
    }

    $('[data-trigger="infos-live"], [data-trigger="infos-live-close"], .infos-live__overlay').on(
        'click',
        () => {
            toggleInfoLive()
        },
    )

    document.addEventListener('show.hc.modal', () => {
        toggleInfoLive('hide')
    })

    $(document).on('contextmenu', 'img', function () {
        const parentIrisCard = $(this).closest('.iris-card')
        if (!parentIrisCard.length) {
            return false
        }
    })
})
